/**  
 * 格式化最后登录时间  
 * @param {string} loginTime 登录时间字符串  
 * @param {string} [format='yyyy-MM-dd HH:mm'] 格式化模式  
 * @returns {string} 格式化后的时间字符串  
 */  
export function formatLastLoginTime(loginTime, format = 'yyyy-MM-dd HH:mm:ss') {  
    // 如果没有传入时间或时间为空，返回空字符串  
    if (!loginTime) return '';  
  
    try {  
      // 使用 Date 对象处理  
      const date = new Date(loginTime);  
      
      // 检查日期是否有效  
      if (isNaN(date.getTime())) return '';  
  
      // 自定义格式化方法  
      return format.replace('yyyy', date.getFullYear())  
        .replace('MM', String(date.getMonth() + 1).padStart(2, '0'))  
        .replace('dd', String(date.getDate()).padStart(2, '0'))  
        .replace('HH', String(date.getHours()).padStart(2, '0'))  
        .replace('mm', String(date.getMinutes()).padStart(2, '0'))
        .replace('ss', String(date.getSeconds()).padStart(2, '0'));  
    } catch (error) {  
      console.error('日期格式化错误:', error);  
      return loginTime;  
    }  
  }  
  
  /**  
   * 获取相对时间描述  
   * @param {string} loginTime 登录时间  
   * @returns {string} 相对时间描述  
   */  
  export function getRelativeLoginTime(loginTime) {  
    if (!loginTime) return '第一次';  
  
    const loginDate = new Date(loginTime);  
    const now = new Date();  
    const diffMs = now.getTime() - loginDate.getTime();  
    
    const diffMinutes = Math.floor(diffMs / (1000 * 60));  
    const diffHours = Math.floor(diffMinutes / 60);  
    const diffDays = Math.floor(diffHours / 24);  
  
    if (diffMinutes < 1) return '刚刚';  
    if (diffMinutes < 60) return `${diffMinutes}分钟前`;  
    if (diffHours < 24) return `${diffHours}小时前`;  
    if (diffDays < 7) return `${diffDays}天前`;  
  
    return formatLastLoginTime(loginTime);  
  }

// 将二维数组转换成对象数组
export const parseTableData = (responseData) => {
  const { meta, data } = responseData;
  return data.map(row => 
    meta.reduce((obj, [field, type], index) => {
      let value = row[index];
      if (type === 'ftDateTime') value = formatLastLoginTime(value, 'yyyy-MM-dd HH:mm:ss');
      if (type === 'ftInteger') value = Number(value);
      obj[field] = value;
      return obj;
    }, {})
  );
};

export const saveToStorage = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

/* 格式化Vant控件返回的日期格式：YYYY-MM-DD */
export function formatDate(date) {  
  const d = new Date(date)  
  const y = d.getFullYear()  
  const m = String(d.getMonth() + 1).padStart(2, '0')  
  const day = String(d.getDate()).padStart(2, '0')  
  return `${y}-${m}-${day}`  
}  

// 格式化日期控件VANT的显示值属性
export function getFormattedDate(date) {
  const d = date; 
  if (!(d instanceof Date)) {
    // 传入字符型时
    const [year = '', month = '', day = ''] = date?.map(String) ?? [];
    return {year, month, day}
  } else
  {
    // 传入日期型时  
    return {
      year: d.getFullYear().toString(),
      month: String(d.getMonth() + 1).padStart(2, '0'),
      day: String(d.getDate()).padStart(2, '0')
    };
  }
}

// 到期状态显示
export function getExpiryStatus(expiryDate)  {
  const today = new Date();
  const expiry = new Date(expiryDate);
  return expiry < today ? '已过期' : '即将到期';
}

export function getExpiryStatusID(expiryDate)  {
  const today = new Date();
  const expiry = new Date(expiryDate);
  const diffTime = expiry - today;  
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));  

  if (expiry < today) return 3
  else 
  if (diffDays <= 30) return 2
  else
  return 1;
}


